import { useEffect, useState } from "react";

const key = (channel) => `khf_cart_${channel}`;

const read = (channel) => {
  try {
    const raw = localStorage.getItem(key(channel));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const useCart = (channel) => {
  const [items, setItems] = useState(() => read(channel));

  useEffect(() => {
    localStorage.setItem(key(channel), JSON.stringify(items));
  }, [channel, items]);

  return [items, setItems];
};
